// Get query string param from url
export const getQueryParam = (key: string) => {
  return new URLSearchParams(window.location.search).get(key);
};
